import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/ui/LoadingSpinner';
import Alert from '../components/ui/Alert';
import Button from '../components/ui/Button';

export function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const userId = searchParams.get('userId');
    const email = searchParams.get('email');
    const role = searchParams.get('role');
    const name = searchParams.get('name');

    if (!token || !userId || !email || !role || !name) {
      setError('Authentication failed: missing required parameters from the auth server.');
      return;
    }

    if (role !== 'OPERATOR' && role !== 'ADMIN') {
      setError('Authentication failed: invalid user role received.');
      return;
    }

    // Store token and user info via AuthContext
    login(token, {
      userId,
      email,
      fullName: name,
      role: role as 'OPERATOR' | 'ADMIN',
      isActive: true,
    });

    // Redirect to dashboard
    navigate('/', { replace: true });
  }, [searchParams, login, navigate]);

  if (error) {
    return (
      <div className="signin-page">
        <div className="signin-card">
          <div className="signin-header">
            <h1>Authentication Error</h1>
          </div>
          <Alert type="error">{error}</Alert>
          <div className="signin-actions">
            <Button variant="primary" onClick={() => navigate('/login', { replace: true })}>
              Back to Sign In
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="signin-page">
      <div className="signin-card">
        <LoadingSpinner size="lg" message="Completing sign-in..." />
      </div>
    </div>
  );
}

export default AuthCallbackPage;
